import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import Typography, {
  TypographyVariant,
} from '../../../component_library/components/Typography';
import type { ITheme } from '../../../component_library/styles/theme';

interface IProps {
  securityNote: string | undefined;
  theme: ITheme;
}

export const SecurityDisclaimer: React.FC<IProps> = ({ securityNote, theme }) =>
  (securityNote ? (
    <Typography
      variant={TypographyVariant.DISCLAIMER}
      color={theme.colors.grayscale.inactiveGrey1}
      theme={theme}
      additionalStyles={{
        marginTop: '16px',
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      <FontAwesomeIcon icon={faLock} style={{ marginRight: '7px' }} />
      {securityNote}
    </Typography>
  ) : null);
